import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  useColorMode,
} from "@chakra-ui/react";

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { Turn as Hamburger } from "hamburger-react";

import { MailIcon, PhoneIcon, UserIcon } from "../../assets/icons/icons";
import { useEffect, useState } from "react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { data } from "../../data";
import useLogout from "../../hooks/useLogout";

import logo from '../../assets/image/logo-light.png'

import { Link as RouterLink } from "react-router-dom";
import { getCurrentColor, headerLink, generateSeoHeaderLink, generateSeoCategoryLink } from "../../constants";
import RenderDesktopCategories from "../RenderDesktopCategories/RenderDesktopCategories";
import { useAtom } from "jotai";
import { userInfoAtom } from "../../atom/user";
import useCookie from "../../hooks/useCookie";
import { useFacetMeta } from "../../hooks/useFacetMeta";
import { FaMoon, FaSun } from "react-icons/fa";
import Switch from "react-switch";
import { selectedCaliberAtom } from "../../atom/calibers";
import VerizonStyleSearchChakra from "./Search";

const Header = () => {
  const { cookies } = useCookie();
  const [showMenu, setShowMenu] = useState(false);
  const { logout } = useLogout();
  const { colorMode, toggleColorMode } = useColorMode();
  const [isScrolled, setIsScrolled] = useState(false);
  const [userInfo] = useAtom(userInfoAtom);
  const [, setSelectedCaliber] = useAtom(selectedCaliberAtom);
  const { facetMappings, mappingsReady } = useFacetMeta();

  useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showMenu]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 72) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const renderMobileCategories = () =>
    data
      .filter((item) => item.category !== "Brands")
      .map((item) => {
        const { category, categoryLink, subCategories } = item;
        return (
          <AccordionItem key={category} border={"none"}>
            <h2>
              <AccordionButton>
                <Box
                  as="span"
                  color={getCurrentColor(colorMode, "whiteC.100", "grayC.1600")}
                  fontSize={"lg"}
                  flex="1"
                  textAlign="left"
                >
                  {category}
                </Box>
                <AccordionIcon
                  color={getCurrentColor(colorMode, "whiteC.100", "grayC.1600")}
                />
              </AccordionButton>
            </h2>
            <AccordionPanel
              pb={4}
              bg={getCurrentColor(colorMode, "whiteC.100", "grayC.1900")}
            >
              <Flex flexWrap={"wrap"}>
                {subCategories.map(({ name, url }) => {
                  // Generate SEO URL for mobile header navigation
                  const seoUrl = mappingsReady && facetMappings
                    ? generateSeoHeaderLink(category, name, facetMappings, cookies.zip)
                    : url;

                  return (
                    <Link
                      as={RouterLink}
                      to={seoUrl}
                      state={headerLink(category, name, cookies.zip)}
                      display={"flex"}
                      alignItems={"center"}
                      fontWeight={500}
                      color={getCurrentColor(
                        colorMode,
                        "blackC.400",
                        "grayC.1600",
                      )}
                      gap={2}
                      py={2}
                      w={"49%"}
                      key={name}
                      onClick={() => {
                        localStorage.setItem("selectedCaliber", name);
                        setSelectedCaliber(name);
                        setShowMenu(false);
                      }}
                    >
                      <ArrowForwardIcon />
                      {name}
                    </Link>
                  );
                })}
              </Flex>
              <Link
                as={RouterLink}
                w={{ base: "100%", xs: "70%", md: "100%" }}
                display={"flex"}
                justifyContent={"center"}
                to={mappingsReady && facetMappings
                  ? generateSeoCategoryLink(category, facetMappings)
                  : categoryLink}
                border={"1px solid"}
                borderColor={"blueC.100"}
                color={getCurrentColor(colorMode, "blueC.100", "whiteC.100")}
                fontSize={"15px"}
                px={"18px"}
                py={"12px"}
                borderRadius={"6px"}
                mt={"24px"}
                fontWeight={500}
                bg={getCurrentColor(colorMode, "whiteC.100", "blueC.400")}
                onClick={() => setShowMenu(false)}
              >
                See More {category}
              </Link>
            </AccordionPanel>
          </AccordionItem>
        );
      });

  const renderDesktopHelloUser = () => {
    return userInfo === null ? (
      <>
        <VerizonStyleSearchChakra />
        <UserIcon />
        <Link as={RouterLink} to="/signup" color={"whiteC.100"} variant="link">
          Sign up
        </Link>
        <Text color={"whiteC.100"}>|</Text>
        <Link as={RouterLink} to="/login" color={"whiteC.100"} variant="link">
          Login
        </Link>
      </>
    ) : (
      <>
        <Text color={"whiteC.100"}>Hello, {userInfo.given_name}</Text>
        <Button
          variant={"link"}
          color={"whiteC.100"}
          onClick={() => logout(userInfo.id)}
        >
          Log out
        </Button>
      </>
    );
  };

  const renderMobile = () =>
    userInfo === null ? (
      <>
        <UserIcon />
        <Link
          as={RouterLink}
          to="/signup"
          color={getCurrentColor(colorMode, "whiteC.100", "grayC.1600")}
          fontSize={"lg"}
          variant="link"
          onClick={() => setShowMenu(false)}
        >
          Sign up
        </Link>
        <Text
          color={getCurrentColor(colorMode, "whiteC.100", "grayC.1600")}
          fontSize={"lg"}
        >
          |
        </Text>
        <Link
          as={RouterLink}
          to="/login"
          color={getCurrentColor(colorMode, "whiteC.100", "grayC.1600")}
          fontSize={"lg"}
          variant="link"
          onClick={() => setShowMenu(false)}
        >
          Login
        </Link>
      </>
    ) : (
      <>
        <Button
          variant={"link"}
          color={getCurrentColor(colorMode, "whiteC.100", "grayC.1600")}
          onClick={() => {
            logout(userInfo.id);
            setShowMenu(false);
          }}
        >
          Log out
        </Button>
      </>
    );

  return (
    <>
      <Flex
        flexDirection={"column"}
        display={{ base: "none", xl: "flex" }}
        zIndex={"99"}
        mb={"70px"}
      >
        <Box
          bg={getCurrentColor(colorMode, "blueC.600", "grayC.1700")}
          position={"fixed"}
          top={isScrolled ? 0 : "auto"}
          left={0}
          w={"100%"}
          transition={"all 0.5s ease"}
        >
          <Flex
            maxW={"1240px"}
            mx={"auto"}
            py={3}
            px={"10px"}
            justifyContent={"space-between"}
          >
            <Link
              as={RouterLink}
              to="/"
              color={"whiteC.100"}
              fontSize={"22px"}
              fontFamily={"secondFont"}
              fontWeight={600}
              textDecor={"none"}
              _hover={{ textDecoration: "none" }}
            >
              <Image
                // src="https://cdn.bulletscout.com/image/logo-light.png"
                src={logo}
                w={"145px"}
                h={"auto"}
                alt="logo"
              />
            </Link>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              maxW={"716px"}
              w={"100%"}
              position={"relative"}
              zIndex={10000}
            >
              {data
                .filter((item) => item.category !== "Brands")
                .map((item, index) => (
                  <RenderDesktopCategories key={index} data={item} />
                ))}
              {/* <Link
                as={RouterLink}
                to="/about-us"
                color={"whiteC.100"}
                _hover={{ textDecoration: "none" }}
              >
                About Us
              </Link> */}
            </Flex>

            <Flex alignItems={"center"} gap={3}>
              <Switch
                checked={colorMode === "dark"}
                onChange={toggleColorMode}
                checkedIcon={
                  <Icon margin="7px" height="20px" width="20px" color="#888888">
                    <FaSun />
                  </Icon>
                }
                uncheckedIcon={
                  <Icon margin="7px" height="20px" width="20px" color="#888888">
                    <FaMoon />
                  </Icon>
                }
                uncheckedHandleIcon={
                  <Icon
                    margin="6px"
                    height="20px"
                    width="20px"
                    color="blue.400"
                  >
                    <FaSun />
                  </Icon>
                }
                checkedHandleIcon={
                  <Icon
                    margin="7px"
                    height="20px"
                    width="20px"
                    color="blue.400"
                  >
                    <FaMoon />
                  </Icon>
                }
                offColor="#404767"
                onColor="#404767"
              />
              <Flex alignItems={"center"} gap={2}>
                {renderDesktopHelloUser()}
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </Flex>

      <Flex
        zIndex={100}
        bg={getCurrentColor(colorMode, "blueC.600", "grayC.1700")}
        px={"20px"}
        py={4}
        display={{ base: "flex", xl: "none" }}
        alignItems={"center"}
        justifyContent={"space-between"}
        position={"relative"}
      >
        <Link
          as={RouterLink}
          to="/"
          textDecor={"none"}
          _active={{ textDecor: "none" }}
          fontSize={"28px"}
          color={"whiteC.100"}
          fontWeight={600}
        >
          <Image
            src="https://cdn.bulletscout.com/image/logo-light.png"
            alt="logo"
            w={"108px"}
            h={"auto"}
          />
        </Link>
        <Flex gap={2}>
          <Flex
            align={"center"}
          >
            <VerizonStyleSearchChakra />
            <Switch
              checked={colorMode === "dark"}
              onChange={toggleColorMode}
              checkedIcon={
                <Icon margin="7px" height="20px" width="20px" color="#888888">
                  <FaSun />
                </Icon>
              }
              uncheckedIcon={
                <Icon margin="7px" height="20px" width="20px" color="#888888">
                  <FaMoon />
                </Icon>
              }
              uncheckedHandleIcon={
                <Icon margin="6px" height="20px" width="20px" color="blue.400">
                  <FaSun />
                </Icon>
              }
              checkedHandleIcon={
                <Icon margin="7px" height="20px" width="20px" color="blue.400">
                  <FaMoon />
                </Icon>
              }
              offColor="#404767"
              onColor="#404767"
            />
          </Flex>
          <Hamburger color="#fff" toggled={showMenu} toggle={setShowMenu} />
        </Flex>

        <Flex
          position={"absolute"}
          overflow={"hidden"}
          w={"100%"}
          transition={"all .3s"}
          top={"90px"}
          left={0}
          overflowY={"auto"}
          zIndex={99}
          bg={getCurrentColor(colorMode, "blueC.600", "grayC.1700")}
          className="scroll-off"
          maxH={showMenu ? "1000px" : "0px"}
          h={showMenu ? "90vh" : "0px"}
          flexDirection={"column"}
          borderTop={"1px solid"}
          borderColor={showMenu ? "grayC.1800" : "transparent"}
        >
          <Accordion w={"100%"} defaultIndex={[0]} allowMultiple>
            {renderMobileCategories()}
          </Accordion>
          <Link
            as={RouterLink}
            to="/about-us"
            fontSize={"lg"}
            px={4}
            py={2}
            mb={11}
            color={getCurrentColor(colorMode, "whiteC.100", "grayC.1600")}
            onClick={() => setShowMenu(false)}
          >
            About Us
          </Link>

          <Flex px={4} alignItems={"center"} gap={2} mb={6}>
            {renderMobile()}
          </Flex>

          <Flex
            gap={5}
            maxW={"1240px"}
            mx={"auto"}
            alignItems={"flex-start"}
            w={"100%"}
            py={6}
            px={"10px"}
            bg={getCurrentColor(colorMode, "whiteC.100", "blueC.500")}
            mt={"auto"}
            flexDirection={"column"}
            pb={10}
          >
            <Flex gap={5} flexDirection={"column"}>
              <Link
                as={RouterLink}
                to="tel:(225) 555-0000"
                display={"flex"}
                gap={1}
                alignItems={"center"}
                _hover={{ textDecoration: "none" }}
                color={getCurrentColor(colorMode, "blackC.100", "grayC.1600")}
                fontWeight={"600"}
                fontSize={"sm"}
              >
                <PhoneIcon
                  color={getCurrentColor(colorMode, "blackC.100", "grayC.1600")}
                />
                (225) 555-0000
              </Link>
              <Link
                as={RouterLink}
                to="mailto:info@bulletscout.com"
                display={"flex"}
                gap={1}
                alignItems={"center"}
                justifyContent={"center"}
                _hover={{ textDecoration: "none" }}
                color={getCurrentColor(colorMode, "blackC.100", "grayC.1600")}
                fontWeight={"600"}
                fontSize={"sm"}
              >
                <MailIcon
                  color={getCurrentColor(colorMode, "blackC.100", "grayC.1600")}
                />{" "}
                info@bulletscout.com
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default Header;
